import { Card, Spin, Typography } from 'antd'
import { useState } from 'react'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import {
  apiCheckWorkstationPasskey,
  getWorkstationStreamingUrl
} from '~/api/genericApi'
import { countDown, showErrors } from '~/utils/helpers'
import PasskeyRegistration from '~/components/PasskeyRegistration'
import PasskeyAuthentication from '~/components/PasskeyAuthentication'

const { Text } = Typography

const Workstation = () => {
  const { token } = useParams()
  const [count, setCount] = useState(15)
  const [showPasskeyFlow, setShowPasskeyFlow] = useState(false)
  const [hasPasskey, setHasPasskey] = useState(false)

  const workstationMutation = useMutation({
    mutationFn: async (assertion) => {
      const response = await getWorkstationStreamingUrl(token, assertion)
      return response
    },
    onSuccess: (response) => {
      if (response.data.connected) {
        window.location.replace(response.data.appstream_url)
      } else {
        countDown(
          15,
          () => {
            window.location.replace(response.data.appstream_url)
          },
          (count) => {
            setCount(count)
          }
        )
      }
    },
    retry: (failureCount, error) => {
      if (error.response.data.should_retry && failureCount < 6) {
        return true
      }

      return false
    },
    onError: showErrors
  })

  useQuery({
    queryFn: async () => await apiCheckWorkstationPasskey(token),
    onSuccess: (response) => {
      setShowPasskeyFlow(response.data.requires_passkey)
      setHasPasskey(response.data.has_passkey || false)

      if (response.data.requires_passkey === false) {
        workstationMutation.mutate()
      }
    },
    refetchOnWindowFocus: false
  })

  if (showPasskeyFlow) {
    if (!hasPasskey) {
      return (
        <PasskeyRegistration
          token={token}
          onSuccess={() => setHasPasskey(true)}
        />
      )
    }
    return (
      <PasskeyAuthentication
        isLoading={workstationMutation.isPending}
        token={token}
        onSuccess={(assertion) => {
          setShowPasskeyFlow(false)
          workstationMutation.mutate(assertion)
        }}
      />
    )
  }

  if (workstationMutation.isFetching) {
    return (
      <div className='centered-container'>
        <Spin size='large' />
        <br />
        Preparing...
      </div>
    )
  }

  if (workstationMutation.isError) {
    return (
      <div className='workstation-form'>
        <Card variant='outlined' style={{ width: 350, textAlign: 'center' }}>
          <Typography.Paragraph>Failed to start your workstation!</Typography.Paragraph>
          <Text>
            Error:{' '}
            {workstationMutation.error.response?.data?.message ||
              'Server error, please try again later'}
          </Text>
        </Card>
      </div>
    )
  }

  return (
    <div className='centered-container'>
      <Spin size='large' />
      <br />
      Redirecting to workstation in {count} seconds...
    </div>
  )
}

export default Workstation
